import { dateParseISO } from "./dateParseISO";
import { format } from "date-fns";
import { formatHour } from "./formatHour";

export function formatStartEndHours(start: string | Date, end: string | Date) {
  const parsedStart = typeof start === "string" ? dateParseISO(start) : start;
  const parsedEnd = typeof end === "string" ? dateParseISO(end) : end;

  const timeDifference = Math.abs(parsedStart.getTime() - parsedEnd.getTime());
  const hoursDifference = Math.floor(timeDifference / (1000 * 60 * 60));

  if (hoursDifference >= 24) {
    return [
      format(parsedStart, "MMMM do, hh:mm a"),
      format(parsedEnd, "MMMM do, hh:mm a")
    ];
  }

  return [formatHour(parsedStart), formatHour(parsedEnd)];
}
